export const SITE_NAME = "همراهتیم";
export const DEFAULT_SITE_ORIGIN = "https://doctoreteam.ir";

export function getSiteOrigin() {
	if (typeof window !== "undefined" && window.location?.origin) {
		return window.location.origin;
	}
	return DEFAULT_SITE_ORIGIN;
}

export function buildCanonicalUrl(pathname) {
	const origin = getSiteOrigin();
	const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
	return `${origin}${path}`;
}

export function stripHtml(html) {
	if (!html) return "";
	return String(html)
		.replace(/<style[\s\S]*?<\/style>/gi, " ")
		.replace(/<script[\s\S]*?<\/script>/gi, " ")
		.replace(/<[^>]+>/g, " ")
		.replace(/&nbsp;/gi, " ")
		.replace(/\s+/g, " ")
		.trim();
}

export function truncateMetaDescription(text, maxLength = 160) {
	if (!text) return "";
	const normalized = text.trim();
	if (normalized.length <= maxLength) {
		return normalized;
	}
	return `${normalized.slice(0, maxLength - 1).trim()}…`;
}

export function publicationMetaDescription(publication) {
	if (!publication) {
		return "مقاله روان‌شناسی و آموزش در همراهتیم";
	}
	const fromText = truncateMetaDescription(stripHtml(publication.text));
	if (fromText) {
		return fromText;
	}
	const title = publication.title?.trim();
	if (title) {
		return truncateMetaDescription(`${title} — مقاله ${SITE_NAME}`);
	}
	return "مقاله روان‌شناسی و آموزش در همراهتیم";
}
